const SVHidden = ({ children }: OnlyChildrenProps) => <span className="hidden">{children}</span>;

export default SVHidden;
